import React from 'react';
import Badge from '../ui/Badge';
import Button from '../ui/Button';

export default function TimelineGroup({ label, count, collapsible = false, collapsed = false, onToggle, children }) {
  return (
    <section className="sp-timeline-group" aria-label={`${label} timeline group`}>
      <div className="sp-timeline-group__header">
        <div>
          <h4 className="sp-value" style={{ fontWeight: 600 }}>{label}</h4>
          <p className="text-xs sp-muted">Grouped timeline activity</p>
        </div>
        <div className="flex items-center gap-2">
          <Badge variant="inactive">{count} event{count === 1 ? '' : 's'}</Badge>
          {collapsible && (
            <Button size="sm" variant="ghost" type="button" onClick={onToggle} aria-expanded={!collapsed}>
              {collapsed ? 'Show' : 'Hide'}
            </Button>
          )}
        </div>
      </div>
      {!collapsed && children}
    </section>
  );
}
